"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcStorage = exports.MemStorage = void 0;
const uint256_1 = require("./uint256");
const utils_1 = require("./utils");
const immutable_1 = require("immutable");
class MemStorage {
    constructor(balance, storage = (0, immutable_1.Map)()) {
        this.balance = balance;
        this.storage = storage;
    }
    getBalance() {
        return this.balance.copy();
    }
    decrementBalance(value) {
        return new MemStorage(this.balance.sub(value));
    }
    incrementBalance(value) {
        return new MemStorage(this.balance.add(value));
    }
    get(location) {
        return this.storage.get(location.toString()) ?? (0, uint256_1.U256)(0);
    }
    set(location, value) {
        return new MemStorage(this.balance, this.storage.set(location.toString(), value));
    }
}
exports.MemStorage = MemStorage;
class RpcStorage {
    constructor(address, rpc, balance = null, adds = (0, immutable_1.List)(), storage = (0, immutable_1.Map)()) {
        this.address = address;
        this.rpc = rpc;
        this.balance = balance;
        this.adds = adds;
        this.storage = storage;
    }
    async get(location) {
        const key = this.key(location);
        let cached = this.storage.get(key);
        if (cached) {
            return cached;
        }
        cached = await this.rpc.getStorageAt(this.address, key);
        cached ?? (cached = (0, uint256_1.U256)(0));
        this.storage.set(key, cached);
        return cached;
    }
    key(location) {
        return `0x${(0, utils_1.dumpU256)(location)}`;
    }
    set(location, value) {
        return new RpcStorage(this.address, this.rpc, this.balance, this.adds, this.storage.set(this.key(location), value));
    }
    async getBalance() {
        if (this.balance) {
            return this.balance;
        }
        this.balance = await this.rpc.getBalance(this.address) ?? (0, uint256_1.U256)(0);
        for (const a of this.adds) {
            this.balance = this.balance.add(a);
        }
        this.adds = (0, immutable_1.List)();
        return this.balance;
    }
    decrementBalance(value) {
        if (!this.balance) {
            throw new Error('Should have checked balance first');
        }
        return new RpcStorage(this.address, this.rpc, this.balance.sub(value), this.adds, this.storage);
    }
    incrementBalance(value) {
        if (this.balance) {
            return new RpcStorage(this.address, this.rpc, this.balance.add(value), this.adds, this.storage);
        }
        return new RpcStorage(this.address, this.rpc, this.balance, this.adds.push(value), this.storage);
    }
}
exports.RpcStorage = RpcStorage;
//# sourceMappingURL=storage.js.map